import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class DietTypeDto extends BaseEntityDto {
  name: string;

  default?: boolean;

  color?: string;

  includesAccommodationExpenses?: boolean;

  @Transform(({ value }) => toEuros(value))
  accommodationExpenses?: number;

  payrollEquivalentDietTypeId?: string | null;

  payrollEquivalentDietType?: DietTypeDto;

  toString(): string {
    return this.name;
  }
}
